import styled from 'styled-components';
import { lightTheme as theme } from '../../../shared/theme';

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    background: ${theme.colors.background};
`;

export const PageShell = styled.section`
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    background: ${theme.colors.paper};
    border-radius: 16px;
    border: 1px solid ${theme.colors.gray200};
    box-shadow: ${theme.colors.shadowSm};
    overflow: hidden;
`;

export const HeaderArea = styled.header`
    background: ${theme.colors.primary};
    color: ${theme.colors.headerText};
    padding: 20px 24px;
`;

export const HeaderStatusRow = styled.div`
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    .title {
        font-size: 22px;
        font-weight: 700;
        line-height: 1.2;
        color: ${theme.colors.headerText};
    }
`;

export const StepperArea = styled.div`
    background: ${theme.colors.paper};
    padding: 18px 20px 0;

    & > div {
        margin-bottom: 0;
    }
`;

export const ContentArea = styled.div`
    background: ${theme.colors.paper};
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SectionCard = styled.section`
    background: ${theme.colors.paper};
    border-radius: 12px;
    box-shadow: ${theme.colors.shadowSm};
    border: 1px solid ${theme.colors.gray200};
    padding: 20px;
`;

export const CardTitle = styled.h3`
    margin: 0 0 14px;
    font-size: 16px;
    font-weight: 700;
    color: ${theme.colors.primary};
`;

export const StepSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StepHint = styled.p`
    margin: 0 0 12px;
    font-size: 14px;
    line-height: 1.6;
    color: ${theme.colors.textSecondary};
`;

export const WarningBox = styled.div`
    margin-top: 12px;
    margin-bottom: 14px;
    padding: 12px;
    background: ${theme.colors.warningBg};
    border: 1px solid ${theme.colors.warning};
    color: ${theme.colors.text};
    border-radius: 8px;
    font-size: 14px;
`;

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
        font-size: 12px;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        color: ${theme.colors.textSecondary};
        font-weight: 700;
    }

    span {
        font-size: 14px;
        line-height: 1.5;
        color: ${theme.colors.text};
    }
`;

export const TextList = styled.ul`
    margin: 0;
    padding-left: 16px;
    color: ${theme.colors.text};

    li {
        font-size: 14px;
        line-height: 1.5;
    }
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    justify-content: ${({ $align }) => ($align === 'left' ? 'flex-start' : 'flex-end')};
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

export const ShippingActionButtonsContainer = styled(ActionButtonsContainer)`
    margin-bottom: 16px;
`;

export const NavigationButtonsContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: end;
    align-items: center;
    flex-wrap: wrap;
`;

export const CheckboxLabel = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: ${theme.colors.text};
    font-size: 14px;
`;

export const CyanCheckbox = styled.input.attrs({ type: 'checkbox' })`
    width: 16px;
    height: 16px;
    accent-color: ${theme.colors.action};
    cursor: pointer;
`;

export const RefusalMessageContainer = styled.div`
    text-align: left;
`;

export const RefusalMessageDescription = styled.p`
    margin: 0 0 10px;
    color: ${theme.colors.text};
    font-size: 14px;
`;

export const RefusalTextarea = styled.textarea`
    width: 100%;
    border: 1px solid ${theme.colors.gray300};
    border-radius: 8px;
    padding: 10px;
    resize: vertical;
    font-size: 14px;
    color: ${theme.colors.text};
`;

export const RefusalMessageError = styled.p`
    margin: 8px 0 0;
    color: ${theme.colors.danger};
    font-size: 13px;
`;
